import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import { handlePostRequest } from '../../service/PostTemplate';
import { useNavigate } from 'react-router-dom';

const AddRole = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [allPermissions, setAllPermissions] = useState(null);
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        roleName: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Role Name must contain only alphanumeric values')
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            roleName: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const mercahntId = user?.data?.merchantId;

           
            const mappedPermissions =
                allPermissions?.flatMap((module) => {
                    const isAnySelected = module.permissions.some((permission) => selectedPermissionIds.some((p) => p.modulePermissionId === permission.id));

                    if (!isAnySelected) return []; 

                    return module.permissions.map((permission) => ({
                        modulePermissionId: permission.id,
                        isAllowed: selectedPermissionIds.some((p) => p.modulePermissionId === permission.id)
                    }));
                }) || [];

            const addRole = {
                merchantId: mercahntId,
                roleName: data?.roleName,
                createdBy: user?.data?.userId,
                permissions: mappedPermissions
            };

            const response = await dispatch(handlePostRequest(addRole, endPoints.addRole, true));
            if (response?.status === 200) {
                navigate('/roles-permissions');
                formik.resetForm();
            }
        }
    });

    const getAllPermissions = async () => {
        const response = await handleGetRequest(endPoints.getallPermissions, true, false, dispatch);
        if (response) {
            setAllPermissions(response?.data);
        }
    };

    useEffect(() => {
        getAllPermissions();
    }, []);

    const handleCheckboxChange = (id) => {
        setSelectedPermissionIds((prev) => {
            const exists = prev.find((p) => p.modulePermissionId === id);
            if (exists) {
                return prev.filter((p) => p.modulePermissionId !== id);
            } else {
                return [...prev, { modulePermissionId: id, isAllowed: true }];
            }
        });
    };

    const handleSelectAll = (modulePermissions) => {
        const modulePermissionIds = modulePermissions.map((p) => p.id);
        const allSelected = modulePermissionIds.every((id) => selectedPermissionIds.some((p) => p.modulePermissionId === id));

        setSelectedPermissionIds((prev) => {
            if (allSelected) {
                return prev.filter((p) => !modulePermissionIds.includes(p.modulePermissionId));
            } else {
                const newSelected = [...prev];
                modulePermissionIds.forEach((id) => {
                    if (!newSelected.find((p) => p.modulePermissionId === id)) {
                        newSelected.push({ modulePermissionId: id, isAllowed: true });
                    }
                });
                return newSelected;
            }
        });
    };

    const handleClick = () => {
        navigate('/roles-permissions');
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Add Role</h3>
            </div>
            <form onSubmit={formik.handleSubmit}>
                <div className="grid p-fluid">
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="roleName">
                                Role Name <span style={{ color: 'red' }}>*</span>
                            </label>
                            <InputText id="roleName" name="roleName" placeholder="Enter Role Name" value={formik.values.roleName} maxLength={30} onChange={formik.handleChange} />
                            {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-12">
                        {allPermissions?.map((module) => {
                            const modulePermissionIds = module.permissions.map((p) => p.id);
                            const allSelected = modulePermissionIds.every((id) => selectedPermissionIds.some((p) => p.modulePermissionId === id));

                            return (
                                <div key={module.moduleId} className="mb-4  border-300 pb-3">
                                    <div className="flex align-items-center gap-3 mb-2">
                                        <label className="flex align-items-center m-0">
                                            <input type="checkbox" checked={allSelected} onChange={() => handleSelectAll(module.permissions)} />
                                        </label>
                                        <p className="text-xl font-semibold m-0">{module.moduleName}</p>
                                    </div>
                                    <div className="pl-4">
                                        {module.permissions.map((permission) => (
                                            <div key={permission.id}>
                                                <label className="flex align-items-center gap-2">
                                                    <input type="checkbox" value={permission.id} checked={selectedPermissionIds.some((p) => p.modulePermissionId === permission.id)} onChange={() => handleCheckboxChange(permission.id)} />
                                                    <span>{permission.permissionName}</span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="flex justify-content-center mt-4 gap-2">
                    <Button label={'Save'} icon={'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                    <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={handleClick} />
                </div>
            </form>
        </div>
    );
};

export default AddRole;
